const authentication = require('../../../react-azure-adb2c2').default;







export const list = (values: any) => {
//   if(values.date1){
//   const date1 = new Date(values.date1);
//   const year = date1.getFullYear();
//   const month = date1.getMonth() + 1;
//   const day = date1.getDate();
//   values.date1 = year + '/' + month + '/' + day
//   }
//   if(values.date2){

//   const date2 = new Date(values.date2);
//   const year2 = date2.getFullYear();
//   const month2 = date2.getMonth() + 1;
//   const day2 = date2.getDate();
   
//   values.date2 = year2 + '/' + month2 + '/' + day2
// }
// values.output =values.output===true?1:0

  // let url = `https://homestationapi.azurewebsites.net/api/kyousai?output=`+values.output+'&name='+values.name+'&date1='+values.date1+'&date2='+values.date2;
  // let url = `https://localhost:44341/api/Kyousai`;
  // let url = `https://moniesapi.azurewebsites.net/api/v1/kyousais`;
    const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais`;
  // let url = `https://localhost:44341/api/banks?output=`+values.output+'&name='+values.name+'&date1='+values.date1+'&date2='+values.date2;

  // alert(url)

  const token = authentication.getAccessToken();

  return fetch(url, {
    method: 'get',
    // body: JSON.stringify({condition:""}),
    headers: { 'Authorization': 'Bearer ' + token }
}).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));



//  return  fetch(url, {
//             method: 'get',
//             // body: JSON.stringify(search),

//             headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

//         }).then(res => res.json())
//         .then(payload => ({ payload }))
//             .catch(error => ({ error }));
//       return  fetch(url, {
//       method: 'get',
//       // body: JSON.stringify(accountinglistset),

//       headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

//   })
//   .then(res => res.json())
//   .then(payload => ({ payload }))
//       .catch(error => ({ error }));
};

export const update = (values: any) => {

  // // let url = `https://homestationapi.azurewebsites.net/api/kyousai?output=`+values.output+'&name='+values.name+'&date1='+values.date1+'&date2='+values.date2;
  // // let url = `https://localhost:44341/api/Kyousai`;
  // let url = `https://moniesapi.azurewebsites.net/api/v1/kyousais`;
  // let url = `https://localhost:44341/api/banks?output=`+values.output+'&name='+values.name+'&date1='+values.date1+'&date2='+values.date2;
  let url = `http://localhost:5000/api/v1/kyousais/update`;
  // alert(url)

  const token = authentication.getAccessToken();
// alert(url)
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
  }).then(res => res.json())
  .then(payload => ({ payload }))
  .catch(error => ({ error }));



//  return  fetch(url, {
//             method: 'get',
//             // body: JSON.stringify(search),

//             headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

//         }).then(res => res.json())
//         .then(payload => ({ payload }))
//             .catch(error => ({ error }));
//       return  fetch(url, {
//       method: 'get',
//       // body: JSON.stringify(accountinglistset),

//       headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

//   })
//   .then(res => res.json())
//   .then(payload => ({ payload }))
//       .catch(error => ({ error }));


};



// export const detail = (Id: number) => {

//             const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + Id;

//             const token = authentication.getAccessToken();

//             return fetch(url, {
//                 headers: { 'Authorization': 'Bearer ' + token }
//             }).then(res => res.json())
//                 .then(payload => ({ payload }))
//                 .catch(error => ({ error }));


//     }



